import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { MetricValueKind, useListMetricAssignmentConditionalChildrenLazyQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ConditionalChildren',
  props: {
    metric: {
      type: Object,
      required: true
    },
    metricValue: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var answer = computed(function () {
      var _props$metricValue;
      return (_props$metricValue = props.metricValue) === null || _props$metricValue === void 0 ? void 0 : _props$metricValue.actual;
    });
    var hasAnsweredYes = computed(function () {
      var _props$metric;
      if (((_props$metric = props.metric) === null || _props$metric === void 0 ? void 0 : _props$metric.valueType) !== MetricValueKind.Binary) {
        return false;
      }
      return [1, '1', true].includes(answer.value);
    });
    var variables = computed(function () {
      var _props$metricValue2;
      return {
        id: (_props$metricValue2 = props.metricValue) === null || _props$metricValue2 === void 0 ? void 0 : _props$metricValue2.metricAssignmentId,
        answer: answer.value
      };
    });
    var _useListMetricAssignm = useListMetricAssignmentConditionalChildrenLazyQuery(variables),
      result = _useListMetricAssignm.result,
      load = _useListMetricAssignm.load,
      refetch = _useListMetricAssignm.refetch;
    watch([answer, function () {
      var _props$metricValue3;
      return (_props$metricValue3 = props.metricValue) === null || _props$metricValue3 === void 0 ? void 0 : _props$metricValue3.metricAssignmentId;
    }], function () {
      // Load on dialog open even when the answer is prefilled.
      // Without immediate fetch, conditional children stay empty until user changes input.
      load() || refetch();
    }, {
      immediate: true
    });
    var directConditionalChildrenAssignments = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listMetricAssignmentConditionalChildren) || [];
    });
    function getChildMetricId(child) {
      return child && child.metric && child.metric.id ? child.metric.id : null;
    }
    function getChildMetricName(child) {
      return child && child.metric && child.metric.name ? child.metric.name : '';
    }
    return {
      __sfc: true,
      props: props,
      answer: answer,
      hasAnsweredYes: hasAnsweredYes,
      variables: variables,
      result: result,
      load: load,
      refetch: refetch,
      directConditionalChildrenAssignments: directConditionalChildrenAssignments,
      getChildMetricId: getChildMetricId,
      getChildMetricName: getChildMetricName
    };
  }
});